import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import Tabs from "../../common/tabs";
import Button from "@edaz/edazkit/Button/index";
import HeaderRow from "@edaz/edazkit/HeaderRow/index";
import RefundForRefundOfRefundsViewModel from "viewModels/finance/refundForRefundOfRefunds/refundForRefundOfRefundsViewModel";

const RefundForRefundOfRefundsView: ViewComponent<RefundForRefundOfRefundsViewModel> = observer(({ vm }) => {
  const exportApprovedClick = vm.exportApprovedClick;
  const approveAllClick = vm.approveAllClick;

  return (
    <>
      <HeaderRow level={3} title={vm.name} className="mb-4">
        {approveAllClick && (
          <Button className="rounded" size="sm" onClick={approveAllClick} disabled={!vm.canApproveAll}>
            {vm.approveAllButtonTitle}
          </Button>
        )}
        {vm.canActionExportApprove && exportApprovedClick && (
          <Button className="rounded" size="sm" onClick={exportApprovedClick} disabled={!vm.canExportApproved}>
            {vm.translate("exportApproved")}
          </Button>
        )}
      </HeaderRow>
      <Tabs vm={vm} />
    </>
  );
});

registerView(RefundForRefundOfRefundsView, RefundForRefundOfRefundsViewModel);
